import { Globe } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import {
  integrationProviderRegistry,
  type IntegrationConfigProps,
  type IntegrationStatusProps,
} from "../integration_registry.js";

function HttpIcon() {
  return <Globe size={20} />;
}

function HttpConfigEditor({ config, update }: IntegrationConfigProps) {
  const suffix = (config.suffix as string) ?? "";

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="suffix">URL suffix</Label>
        <Input
          id="suffix"
          value={suffix}
          onChange={e => update({ ...config, suffix: e.target.value })}
          placeholder="my-source"
        />
        <p className="text-xs text-muted-foreground">
          Items POSTed to{" "}
          <code>/api/o/&lt;org&gt;/tip/{suffix || "<suffix>"}</code> will land
          in your inbox.
        </p>
      </div>
    </div>
  );
}

function HttpStatusDisplay({ connected, error }: IntegrationStatusProps) {
  if (connected) {
    return <Badge variant="default">Connected</Badge>;
  }
  return <Badge variant="destructive">{error ?? "Not connected"}</Badge>;
}

integrationProviderRegistry.register({
  type: "http",
  kind: "source",
  label: "HTTP",
  icon: HttpIcon,
  ConfigEditor: HttpConfigEditor,
  StatusDisplay: HttpStatusDisplay,
});
